import type { Capabilities, SubscriptionDetail } from '@rtkwlf/rendall';
import dayjs from 'dayjs';

export const getConfigurationRulesFeatureReleases = (
  subscriptions: SubscriptionDetail | undefined,
  legacyCapabilities: Capabilities | undefined,
) => {
  if (!subscriptions || !legacyCapabilities) {
    return [];
  }

  const hasAccessToAlertManagement = !!legacyCapabilities?.canManageAlertConfig;

  return [
    {
      newsItemId:
        'configuration-rules:whatsNew.newsItems.selfServeAlertConfigurations',
      date: dayjs('2025-02-06T12:00:00Z'),
      hasAccess: hasAccessToAlertManagement,
      featureFlag: undefined,
    },
  ];
};
